import classNames from 'classnames/bind';
import { gql } from '@apollo/client';
import styles from './AcfAppBadges.module.scss';
import { AppBadges } from '@/components';

let cx = classNames.bind(styles);

export default function AcfAppBadges(props) {
	const { appBadges, attributes } = props;
	const className = attributes.className?.split(' ') || [];
	return (
		<AppBadges className={cx([...className])} align={attributes.alignBadges} id={attributes.anchor} googleUrl={appBadges.googlePlayUrl} appleUrl={appBadges.appleAppStoreUrl} outlined={!appBadges.areFilled} />
	);
}

AcfAppBadges.fragments = {
	key: `AcfAppBadgesFragment`,
	entry: gql`
		fragment AcfAppBadgesFragment on AcfAppBadges {
			attributes {
        anchor
        alignBadges: align
				className
			}
			appBadges {
				appleAppStoreUrl
        googlePlayUrl
        areFilled
			}
		}
	`,
};

AcfAppBadges.config = {
	name: 'AcfAppBadges',
};
AcfAppBadges.displayName = 'AcfAppBadges';